import { render, staticRenderFns } from "./Businessparks.vue?vue&type=template&id=d6549618&scoped=true"
import script from "./Businessparks.vue?vue&type=script&lang=js"
export * from "./Businessparks.vue?vue&type=script&lang=js"
import style0 from "./Businessparks.vue?vue&type=style&index=0&id=d6549618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6549618",
  null
  
)

export default component.exports